<template>
  <div>
    <Header :image="storeInfo.image">
      {{ storeInfo.name }}
    </Header>
    <main id="#main">
      <div class="c-card-default">
        <h2 class="c-level1 c-attention">
          まだ予約は<br>完了していません
        </h2>
        <div class="p-temporary__mailImg">
          <img src="@/assets/temporary_mail.png">
        </div>
        <p class="c-eyecatchText">
          お送りしたメールのURLから<br>
          30分以内に<br>
          予約を行なってください
        </p>
        <p class="c-text__notice--min u-mt30">
          ※メールが届かない場合、メールアドレスの入力間違いで受信できないか、迷惑メールフォルダに保存されている可能性があります。ご確認の上、受信が確認できない場合は、再度予約してください。
        </p>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapState, mapActions } from 'vuex'
import { Mixin } from '@/mixin'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  head: {
    title: function () {
      return {
        inner: this.storeInfo.name,
        separator: '|',
        complement: '仮予約完了'
      }
    }
  },
  computed: {
    ...mapState({
      storeInfo: 'storeInfo'
    })
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      vm.$store.commit('SET_LOADING', true)
      promises.push(vm.$store.dispatch('LOAD_STORE_INFO', { storeid: route.params.storeid }))
      await Promise.all(promises).then(function () {
        vm.$emit('updateHead')
        vm.$store.commit('SET_LOADING', false)
      }).catch(function (error) {
        vm.$store.commit('SET_LOADING', false)
        alert(error.message)
      })
    })
  },
  mixins: [Mixin],
  methods: {
    ...mapActions(['LOAD_STORE_INFO', 'LOAD_MENU_INFO'])
  }
}
</script>
